<template>
  <div ref="detailEasyTool" class="detail-easy-tool">
    <template v-if="showSendBox">
      <div class="send-box">
        <DetailCommentSendMin
          ref="sendBox"
          :on-ok="onComment"
          placeholder="友善发言，文明交流"
          send-btn-text="发送"
          :show-video="false"
          @cancel="showSendBox = false"
        />
      </div>
    </template>
    <template v-else>
      <div class="input" @click="handleComment">说点什么吧</div>
      <div class="bar">
        <div class="item" @click="onLike">
          <img
            class="icon"
            :src="
              `${
                detail.is_like
                  ? require('@/assets/images/aside_dianzanle.png')
                  : require('@/assets/images/aside_dianzan.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="divider"></div>
        <div class="item" @click="onFavorite">
          <img
            class="icon"
            :src="
              `${
                detail.is_favorite
                  ? require('@/assets/images/aside_shoucangle.png')
                  : require('@/assets/images/aside_shoucang.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
        </div>
        <div class="divider"></div>
        <div class="item" @click="handleShare">
          <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { apiContentLike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";
import DetailCommentSendMin from "./detailCommentSendMin";

export default {
  name: "DetailEasyTool",
  components: { DetailCommentSendMin },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showSendBox: false,
      resizeObserver: null
    };
  },
  watch: {
    async showSendBox(value) {
      await this.$nextTick();
      /** @type {HTMLDivElement} */
      const el = this.$refs.detailEasyTool;
      if (!el) return;
      const height = Number(
        getComputedStyle(el)
          .getPropertyValue("height")
          .replace("px", "")
      );
      this.$emit("heightChange", height);
    }
  },
  mounted() {
    this.observeDomChange();
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    onLike() {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onComment(data) {
      this.$emit("comment", data);
    },
    onHeightChange(height) {
      this.$emit("heightChange", height);
    },
    handleComment() {
      this.showSendBox = true;
    },
    handleShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";
      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    observeDomChange() {
      // 获取目标元素
      const targetElement = this.$refs.detailEasyTool;

      // 创建 ResizeObserver 实例
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const { height } = entry.contentRect; // 获取新的高度
          this.$emit("heightChange", height);
        }
      });

      // 开始观察目标元素
      resizeObserver.observe(targetElement);

      // 如果不再需要观察，可以使用 disconnect()
      /* resizeObserver.disconnect(); */

      this.resizeObserver = resizeObserver;
    }
  }
};
</script>
<style lang="less" scoped>
.detail-easy-tool {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  padding: 13px 14px;
  display: flex;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #f0f0f0;
  .send-box {
    flex-grow: 1;
  }
  .input {
    cursor: text;
    flex-grow: 1;
    height: 34px;
    line-height: 34px;
    color: #bbbbbb;
    background-color: #f2f2f2;
    border-radius: 4px;
    padding-left: 8px;
  }
  .bar {
    display: flex;
    align-items: center;
    gap: 8px;
    .item {
      display: flex;
      align-items: center;
      gap: 6px;
      .icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
      .txt {
        color: #424242;
        font-size: 12px;
      }
    }
    .divider {
      width: 1px;
      height: 16px;
      background-color: #e3e3e3;
    }
  }
}
</style>
